export default "<app-header *ngIf=\"showHeader == true\"></app-header>\n<router-outlet></router-outlet>";